import HeroImage from "../components/layouts/HeroImage";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

const ErrorPage = () => {
    const navigate = useNavigate();
    useEffect(() => {
        setTimeout(() => {
            navigate('/')
        },5000)
    }, []);

    return <>
        <HeroImage title='Questa pagina non esiste... Verrai reindirizzato alla home tra pochi secondi' />
    </>;
}

export default ErrorPage;